import React, { useEffect, useState } from "react";
import "./Common_Category_Offcanvas.css";
import { Nav, Offcanvas } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";

const Common_Category_Offcanvas = ({
  show,
  onHide,
  titleText,
  navs,
  handleClickCategory,
  activeIndex,
  setActiveIndex,
  ...props
}) => {
  const navigate = useNavigate();

  const hasAnySubcat = navs.some((item) => item.subcat?.length > 0);
  const dispatch = useDispatch();
  // const categoriesData = useSelector((state) => state.master.categories);

  // useEffect(() => {
  //   dispatch(getAllCategories());
  // }, [dispatch]);

  return (
    <section>
      <Offcanvas
        show={show}
        onHide={onHide}
        {...props}
        className="Common_Category_Offcanvas"
      >
        <Offcanvas.Body>
          <div className="main_content_div">
            <div className="title_div">
              <p className="title_text">CATEGORIES</p>
            </div>

            <div className="all_navs_holder">
              <div className="cat_left_div">
                {navs ?.filter((item) => item?.status !== false) 
                .map((item, index) => {
                  if (item.subcat?.length > 0) {
                  // if (item.subcat?.filter((s) => s?.status !== false)?.length > 0) {
                    return (
                      <div
                        key={index}
                        className={`left_item ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => {
                          handleClickCategory?.(item?.catId);
                          setActiveIndex(index);
                        }}
                      >
                        <p className="link_text">{item.catName}</p>
                      </div>
                    );
                  }

                  return (
                    <div
                      key={index}
                      className={`left_item ${
                        activeIndex === index ? "active" : ""
                      }`}
                      onClick={() => {
                        handleClickCategory?.(item?.catId);

                        navigate(
                          item?.link ||
                            `/product-listing/${item?.catId}?sub_category_id=${
                              item?.subCatId
                            }&subcategory_id=${
                              item?.subCatId
                            }&category_name=${encodeURIComponent(
                              item?.catName,
                            )}&subcategory_name=${encodeURIComponent(
                              item?.name,
                            )}&category_image=${encodeURIComponent(
                              item?.catImage,
                            )}`,
                        );

                        // navigate(item?.link);
                        onHide();
                      }}
                    >
                      <p className="link_text link">{item.catName}</p>
                    </div>
                  );
                })}

                {!hasAnySubcat && (
                  <div className="close_icon_div left_cat" onClick={onHide}>
                    <img
                      src="/assets/images/icons/close.png"
                      className="close_img"
                      alt="close"
                    />
                  </div>
                )}
              </div>

              {hasAnySubcat && (
                <div className="cat_right_div">
                  {navs[activeIndex]?.subcat?.length > 0 && (
                    <>
                      {navs[activeIndex].subcat ?.filter((s) => s?.status !== false)
                      .map((sub, i) => (
                        <div
                          className="right_item"
                          key={i}
                          onClick={() => {
                            navigate(
                              `/product-listing/${
                                navs[activeIndex]?.catId
                              }?sub_category_id=${sub?.id}&subcategory_id=${
                                sub?.id
                              }&category_name=${encodeURIComponent(
                                navs[activeIndex]?.catName,
                              )}&subcategory_name=${encodeURIComponent(
                                sub?.name,
                              )}&category_image=${encodeURIComponent(
                                navs[activeIndex]?.catImage,
                              )}`,
                            );
                            onHide();
                          }}
                        >
                          <p className="right_text">{sub?.subCatName}</p>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          {hasAnySubcat && (
            <div className="close_icon_div" onClick={onHide}>
              <img
                src="/assets/images/icons/close.png"
                className="close_img"
                alt="close"
              />
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </section>
  );
};

export default Common_Category_Offcanvas;
